<template>
  <section class="tradein-offer-request">
    <Chatbot
      key="chatbot"
      class="chatbot"
      :flow="tradeinOfferRequestFlow"
      @finished="() => null" />

    <Footer />
  </section>
</template>

<script>
import Chatbot from "@/components/chatbot/Chatbot"
import Footer from "@/components/ui/Footer"
import tradeinOfferRequestFlow from "@/chatbot-flows/tradein-offer-request.flow.js"

export default {
  name: "TradeinOfferRequest",
  components: {
    Chatbot,
    Footer
  },
  data() {
    return { tradeinOfferRequestFlow }
  },
  mounted() {
    this.$store.commit("tradeinOfferRequest/flow/resetState")
  }
}
</script>

<style lang="scss" scoped>
.tradein-offer-request {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;

  .chatbot {
    flex: 1;
  }
}
</style>

